export const refreshCurrentSubmodule = () => {
  // Find the element under class dt-module with class dt-page
  const dtPage = document.querySelector('.dt-module .dt-page')?.__vue__;
  console.log({ 'list-refresher.js:4 dtPage': dtPage });
  if (dtPage?.fetchList) {
    dtPage.fetchList();
  } else if (dtPage?.fetchListReset) {
    dtPage.fetchListReset();
  }
}

export const isCurrentSubmoduleRefreshable = (route_name) => {
  console.log(route_name);
  // Find the element under class dt-module with class dt-page
  const dtPage = document.querySelector('.dt-module .dt-page')?.__vue__;
  console.log({ 'list-refresher.js:4 dtPage': dtPage });
  return dtPage?.fetchList || dtPage?.fetchListReset;
}